import React, { useState } from 'react';
const faqs: {
  question: string;
  answer: string;
}[] = [{
  question: '¿Cómo recibo el MegaPack después de comprar?',
  answer: 'Todo es 100% digital en formato PDF. Recibís un email con el acceso inmediato dentro de los 5 minutos posteriores a la compra. Sin esperas, sin envíos físicos.'
}, {
  question: '¿Necesito experiencia previa en detailing para que funcione?',
  answer: 'No. El sistema está diseñado desde cero para que cualquier persona sin experiencia pueda aprender las técnicas correctas y arrancar su propio negocio. El Tomo 1 empieza desde los fundamentos absolutos.'
}, {
  question: '¿Sirve si ya intenté aprender con videos de YouTube?',
  answer: 'Sí, especialmente para vos. Los videos de YouTube son contradictorios y están desorganizados. El MegaPack es un sistema ordenado paso a paso que va desde el lavado técnico hasta el sellado cerámico avanzado sin saltos ni contradicciones.'
}, {
  question: '¿Los 4 bonos están en las dos ofertas?',
  answer: 'Sí. Los 4 bonos exclusivos están incluidos en ambas opciones sin costo extra. La diferencia del plan con El Método Cerámico™ es que agrega el sistema avanzado de sellado cerámico, clientes de lujo y cómo cobrar +$400.000 por servicio.'
}, {
  question: '¿Sirve si no tengo garage propio ni herramientas profesionales?',
  answer: 'Sí. El Tomo 4 (Química y Costos) está diseñado para que empieces con el mínimo de herramientas e inviertas de forma inteligente. Muchos alumnos arrancaron con menos de $30.000 en insumos y recuperaron la inversión en el primer trabajo.'
}, {
  question: '¿Cuánto tiempo necesito para hacer mi primer trabajo profesional?',
  answer: 'Con el Tomo 1 y el Tomo 2 podés hacer tu primer lavado técnico y pulido básico en el mismo fin de semana que recibís el material. No necesitás terminar todo el sistema para arrancar a cobrar.'
}, {
  question: '¿Qué pasa si cometo un error y rayo el auto de un cliente?',
  answer: 'Para eso existe el Checklist del Bono 1. Cada paso del proceso está documentado para que nunca improvises. Además el Tomo 1 explica exactamente cómo hacer la inspección de recepción y documentar el estado previo del vehículo para protegerte legalmente.'
}, {
  question: '¿Qué diferencia tiene este sistema con otros cursos de detailing?',
  answer: 'No es un curso genérico de "cómo lavar autos". Es un sistema completo que incluye técnica, química, negocio y captación de clientes al mismo tiempo. La mayoría de los cursos solo enseñan uno de los cuatro pilares.'
}, {
  question: '¿Por qué elegir el MegaPack + El Método Cerámico™ y no el estándar?',
  answer: 'El Método Cerámico™ agrega el sistema de sellado cerámico avanzado (9H, Grafeno y Vidrio Líquido), la estrategia para cobrar +$400.000 por servicio y el método para captar clientes de BMW, Mercedes y Porsche en tu ciudad. Si querés trabajar en autos de alta gama y cobrar en serio, El Método Cerámico™ es la diferencia.'
}, {
  question: '¿Tiene garantía real?',
  answer: 'Sí. Garantía Detailer Pro™ de 30 días sin preguntas. Si en 30 días no mejoraste tu técnica o no conseguiste nuevos clientes, te devolvemos el 100% de tu dinero. Sin formularios. Sin drama.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: '#0d0d0d',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-140">
      <div className="mx-auto max-w-3xl" data-id="element-141">
        <h2 className="text-3xl font-black text-center leading-10 text-white m-0 mb-8" data-id="element-142">
          ❓ PREGUNTAS FRECUENTES
        </h2>

        <div className="space-y-2" data-id="element-143">
          {faqs.map((faq, i) => <div key={i} className="transition-colors border border-yellow-400/20 rounded-lg shadow-sm" style={{
          backgroundColor: openIndex === i ? 'rgba(234, 179, 8, 0.05)' : 'rgba(255,255,255,0.02)'
        }} data-id="element-144">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} aria-expanded={openIndex === i} className="flex w-full items-center justify-between gap-3 text-left bg-transparent cursor-pointer border-0 px-4 py-3 m-0" style={{
            fontFamily: 'inherit'
          }} data-id="element-145">
                <span className="text-sm font-bold text-white" data-id="element-146">
                  ❓ {i + 1} — {faq.question}
                </span>
                <span className={`shrink-0 text-lg text-yellow-400 transition-transform duration-200 ${openIndex === i ? 'rotate-45' : ''}`} data-id="element-147">
                  +
                </span>
              </button>

              {/* Answer */}
              {openIndex === i && <div className="px-4 pb-4" data-id="element-148">
                  <p className="text-sm text-gray-300 m-0 leading-relaxed" data-id="element-149">
                    {faq.answer}
                  </p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}